module.exports = __webpack_public_path__ + "static/media/VerizonNHGDS-Regular.2db9b74a.ttf";